module.exports = __webpack_public_path__ + "media/images/img/tag_company/pwc_tag-f1e1efe8432bbe0be3ff4a4562d2821a.png";